import { useLocation, useNavigate } from "svelte-navigator";
import { derived } from 'svelte/store';

export const useUrlParams = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const store = derived(location, ($location) => {
    const query = new URLSearchParams($location.search);
    return {
      analysisid: query.get("analysisid"),
      idproject: query.get("idproject"),
      survey: query.get("survey"),
      area: query.get("area"),
      department: query.get("department"),
      currentStep: Number(query.get("currentStep") || 0),
      userid: query.get("userid"),
      view: query.get("view") || "main",
      currentUrl: $location.pathname + $location.search,
      pathname: $location.pathname,
      search: $location.search
    };
  });

  return {
    subscribe: store.subscribe,
    updateParam: (key, value, options = { replace: false }) => {
      const query = new URLSearchParams(window.location.search);
      query.set(key, value);
      navigate(`?${query.toString()}`, { replace: options.replace });
    }
  };
};
